
import PropTypes from 'prop-types';
import Position from './Position';

export default PropTypes.shape({
  id: PropTypes.number,
  locationTypeId: PropTypes.number,
  positionId: PropTypes.number,
  order: PropTypes.number,
  group: PropTypes.number,
  gender: PropTypes.string,
  allowDoubleBooking: PropTypes.bool,
  enabled: PropTypes.bool,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  position: Position
})